import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import Button from 'ui/components/generic/Button'

const Wrapper = styled.section`
  margin-bottom: 60px;
`

export default class ButtonModule extends Component {
  render() {
    const {
      link,
      external
    } = this.props

    return(
      <Wrapper>
        <Container fluid>
          <Row>
            <Col
              sm={6}
              smOffset={3}
            >
              <Button
                title={link.title}
                link={link.url}
                external={external}
                target={link.target}
              />
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/ButtonModule/index.js